'use strict';

module Patersons {

    export interface FreezeWindow {
        asAtFreezeDate: string;
        isInFreezeWindow: boolean;
    }
    export class ReportService extends BaseService {

        getFile(url): ng.IPromise<void> {
            this.log.info("reportService getting binary pdf data for" + url);
            return this.http.get(url, { responseType: 'arraybuffer' })
                .then(data => {
                    var file = new Blob([data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }, (reason) => { return this.errorHandler(reason, "Error retrieving binary pdf data")});
        };
        getAllAccoladeNotifications(): ng.IPromise<Array<any>>{
            this.log.info("reportService getting investor docs notifications");
            return this.get('/dataService/api/InvestorDocs/GetAllNotifications');
        }
        acknowledgeAccoladeNotifications(): ng.IPromise<void>{
            this.log.info("reportService acknolegding investor docs notifications");
            return this.get('/dataService/api/InvestorDocs/AcknowledgeAllNotifications');
        }
        getReport(reportType: ReportType, accountCode: string, dateFrom: Date, dateTo: Date): ng.IPromise<AbstractReport> {
            return this.get("/dataService/api/Reporting?reportType=" + reportType + "&accountCode=" + accountCode + "&dateFrom=" + dateFrom.toISOString() + "&dateTo=" + dateTo.toISOString());
        };
        checkFreezeWindow(): ng.IPromise<FreezeWindow> {
            return this.get("/dataService/api/Reporting/CheckFreezeWindow");
        };
    }
}